import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAuthorization } from "../../../services/config";
import { updateLoading } from "../loader";
import API_ROUTES from "../../../constants/apiRoutes";
import {
  ToastNotifyError,
  ToastNotifySuccess,
} from "../../../components/CommonComponents/Toast/ToastNotify";

const {
  V1: {
    ADD_TO_BAG,
    CLEAR_BAG,
    BAG_CHECKOUT,
    CANCEL_ORDER,
    UPDATE_ORDER_ITEM_STATUS,
    UPDATE_TRIP_DATE,
    CHECKOUT_KEEP_ITEMS,
    STATUS_COLOR,
    REVIEW,
    DOWNLOAD_INVOICE
  } = {},
} = API_ROUTES;

const fetchBagProducts = createAsyncThunk(
  "Bag/get",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(ADD_TO_BAG);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const fetchStatus = createAsyncThunk(
  "Bag/getStatus",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(STATUS_COLOR);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const addToBag = createAsyncThunk(
  "Bag/add",
  async (payload, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(ADD_TO_BAG, payload);
      if (response?.response?.data?.non_field_errors?.[0])
        ToastNotifyError(response?.response?.data?.non_field_errors?.[0]);
      if (response?.data?.message) ToastNotifySuccess(response?.data?.message);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const removeFromBag = createAsyncThunk(
  "Bag/remove",
  async (param, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.delete(`${ADD_TO_BAG}?id=${param}`);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const updateOrderItemStatus = createAsyncThunk(
  "Bag/UpdateOrderItemStatus",
  async (payload, { dispatch, getState }) => {
    const API = getAuthorization(getState, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.patch(
        UPDATE_ORDER_ITEM_STATUS + payload.id,
        payload.data
      );
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const cancelOrder = createAsyncThunk(
  "Bag/OrderRemove",
  async (payload, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(CANCEL_ORDER, payload);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const updateBag = createAsyncThunk(
  "Bag/updateQuantity",
  async (payload, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.patch(ADD_TO_BAG, payload);
      if (response?.response?.data?.non_field_errors?.[0])
        ToastNotifyError(response?.response?.data?.non_field_errors?.[0]);
      if (response?.data?.message) ToastNotifySuccess(response?.data?.message);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const clearBag = createAsyncThunk(
  "Bag/clear",
  async (id, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.delete(CLEAR_BAG + id + "/");
      dispatch(updateLoading(false));
      if (response?.data?.message) {
        // ToastNotifySuccess(response?.data?.message);
      } else if (response?.response?.data?.detail) {
        ToastNotifyError(response?.response?.data?.detail);
      }
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const fetchCheckoutBag = createAsyncThunk(
  "Bag/checkout",
  async (dataToSend, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(BAG_CHECKOUT, dataToSend);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);
const updateTripDate = createAsyncThunk(
  "Closet/updateTripDate",
  async (dataToSend, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    const { querry, data } = dataToSend;
    try {
      dispatch(updateLoading(true));
      const response = await API.patch(UPDATE_TRIP_DATE + querry, data);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const fetchCheckoutKeepItems = createAsyncThunk(
  "Bag/checkoutKeepItems",
  async (dataToSend, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(CHECKOUT_KEEP_ITEMS, dataToSend);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);
const fetchPastReviews = createAsyncThunk(
  "Bag/pastReviews",
  async (query, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(REVIEW + query);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);
const fetchPostReviews = createAsyncThunk(
  "Bag/postReviews",
  async (dataToSend, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(REVIEW, dataToSend);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);
const fetchPostReviewById = createAsyncThunk(
  "Bag/postReviewById",
  async (id, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(REVIEW + id);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);
const fetchUpdateReview = createAsyncThunk(
  "Bag/UpdateReviews",
  async (dataToSend, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
    });
    const {id, data} = dataToSend;
    try {
      dispatch(updateLoading(true));
      const response = await API.patch(REVIEW + id, data);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);
const DownloadInvoice = createAsyncThunk(
  "past/downloadInvoice",
  async (id, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(DOWNLOAD_INVOICE + id + "/download/");
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      dispatch(updateLoading(false));
      throw err;
    }
  }
);


const bagSlice = createSlice({
  name: "Bag",
  initialState: {
    bagItems: [],
    isLoading: false,
    error: null,
    keepItemsPayment: {}
  },
  reducers: {
    resetBag: (state) => {
      state.bagItems = [];
      state.isLoading = false;
      state.error = null;
      state.keepItemsPayment = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBagProducts.fulfilled, (state, action) => {
        state.bagItems = action.payload.data || [];
      })
      .addCase(addToBag.fulfilled, (state, action) => {
        state.bagItems.push(action.payload);
      })
      // .addCase(removeFromBag.fulfilled, (state, action) => {
      //   state.bagItems = state.bagItems.filter(item => item.id !== action.meta.arg);
      // })
      // .addCase(updateBagQuantity.fulfilled, (state, action) => {
      //   const item = state.bagItems.find(item => item.id === action.payload.id);
      //   if (item) {
      //     item.quantity = action.payload.quantity;
      //   }
      // })
      .addCase(clearBag.fulfilled, (state) => {
        state.bagItems = [];
      });
      builder.addCase(fetchCheckoutKeepItems.pending, (state) => {
        state.isLoading = true;
      });
      builder.addCase(fetchCheckoutKeepItems.fulfilled, (state, action) => {
        state.isLoading = false;
        state.keepItemsPayment = action.payload.data
      });
      builder.addCase(fetchCheckoutKeepItems.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

const selectBagItems = (state) => state.Bag;

const { reducer, actions } = bagSlice;
const { resetBag } = actions;

export {
  updateOrderItemStatus,
  addToBag,
  cancelOrder,
  selectBagItems,
  clearBag,
  fetchBagProducts,
  removeFromBag,
  updateBag,
  fetchCheckoutBag,
  updateTripDate,
  fetchCheckoutKeepItems,
  fetchStatus,
  fetchPastReviews,
  fetchPostReviews,
  fetchPostReviewById,
  fetchUpdateReview,
  DownloadInvoice,
  resetBag
};

export default reducer;
